import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#invoice_svg__a)">
      <path d="M14.53 18c-2.29 0-4.27-1.44-5.17-3.5h-.85c-.55 0-1-.45-1-1s.45-1 1-1h.36c-.01-.17-.02-.33-.02-.5h-.34c-.55 0-1-.45-1-1s.45-1 1-1h.66c.78-2.33 2.89-4 5.37-4 .55 0 1 .45 1 1s-.45 1-1 1c-1.36 0-2.56.81-3.2 2h2.17c.55 0 1 .45 1 1s-.45 1-1 1h-2.66c0 .17 0 .34.03.5h2.64c.55 0 1 .45 1 1s-.45 1-1 1h-1.85c.68.91 1.72 1.5 2.88 1.5.55 0 1 .45 1 1s-.45 1-1 1z" />
      <path d="M20 22H4c-.55 0-1-.45-1-1V7c0-.27.11-.52.29-.71l4-4A1 1 0 0 1 8 2h12c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1M5 20h14V4H8.41L5 7.41z" />
      <path d="M8 8H4c-.55 0-1-.45-1-1s.45-1 1-1h3V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="invoice_svg__a">
        <path fill="#fff" d="M3 2h18v20H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInvoice;
